module.exports = __webpack_public_path__ + "static/media/009.9c6ab2f9.jpg";